export default `float de(vec3 p) {
    vec3 r = vec3(0.2, 0.25, 0.05); 
    float k0 = length(p/r);
    float k1 = length(p/(r*r));
    return k0*(k0-1.0)/k1;
  }`